"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const utils_1 = require("./utils");
const Alert = (_a) => {
    var { type, status, message, title, dismissible, dismissed, onDismiss, className, style } = _a, rest = __rest(_a, ["type", "status", "message", "title", "dismissible", "dismissed", "onDismiss", "className", "style"]);
    const [localDismissed, setLocalDismissed] = react_1.useState(dismissed);
    react_1.useEffect(() => {
        setLocalDismissed(dismissed);
    }, [dismissed]);
    const onCloseClicked = () => {
        setLocalDismissed(true);
        onDismiss && onDismiss();
    };
    if (dismissible && localDismissed) {
        return null;
    }
    const titleElement = title ? (react_1.default.createElement("p", null,
        ' ',
        react_1.default.createElement("strong", null,
            " ",
            title,
            " "),
        ' ')) : ('');
    const dismissibleButton = dismissible ? (react_1.default.createElement("button", { type: "button", className: "close", onClick: onCloseClicked }, "\u00D7")) : ('');
    return (react_1.default.createElement("div", Object.assign({ className: emotion_1.cx('alert', `alert-${status || type || 'danger'}`, { 'alert-dismissible': dismissible }, className), style: style }, rest),
        dismissibleButton,
        titleElement,
        message));
};
Alert.propTypes = {
    status: prop_types_1.default.oneOf(['success', 'info', 'warning', 'danger']),
    message: prop_types_1.default.node.isRequired,
    title: prop_types_1.default.node,
    dismissible: prop_types_1.default.bool,
    dismissed: prop_types_1.default.bool,
    onDismiss: prop_types_1.default.func,
    style: react_style_proptype_1.default,
    className: prop_types_1.default.string,
    type: utils_1.deprecatedProp(prop_types_1.default.oneOf(['success', 'info', 'warning', 'danger']), 'Use `status` instead.'),
};
Alert.defaultProps = {
    dismissible: true,
    dismissed: false,
    style: {},
    className: '',
};
exports.default = Alert;
